import { useIsMobile } from "@/hooks/use-mobile";
import { useLanguage } from "@/context/LanguageContext";
import { carDetailsLabels } from "@/i18n";
import BtnNavigateBack from "../ui/btn_navigate_back";

interface CarHeaderProps {
  type: string | undefined;
  overlay?: boolean;
}

const CarHeader = ({ type: _type, overlay }: CarHeaderProps) => {
  const { language } = useLanguage();
  const labels = carDetailsLabels(language);
  const isMobile = useIsMobile();

  return (
    <BtnNavigateBack
      label={labels.back}
      preferHistory
      to="/auctions"
      overlay={overlay ?? isMobile}
    />
  );
};

export default CarHeader;
